"use strict";

exports.__esModule = true;
/*:: export type branchNameType = Map<string, string>;*/
/*:: export type entityType = {
  key: string,
  prefixTitleId: number,
  photos: Map<string, string>,
  name: Map<string, string>,
  about: Map<string, string>,
  branches: Map<string, branchNameType>,
};*/
/*:: export type branchType = {
  key: string,
  lat: number,
  lng: number,
  isoCode: string,
  name: Map<string, string>,
  floor: Map<string, string>,
  landMark: Map<string, string>,
  streetName: Map<string, string>,
  apartmentNumber: Map<string, string>,
  buildingNumber: number,
  number: number,
  countryCode: string,
  phoneTypeId: number,
  isPending: boolean,
  users: Map<string, Array<string>>,
  isFullyLoaded: boolean,
};*/
/*:: export type userType = {
  key: string,
  mainSpecialty: ?string,
  subSpecialties: Array<string>,
  prefixTitleId: number,
  statusId: number,
  firstName: Map<string, string>,
  lastName: Map<string, string>,
  photos: Map<string, string>,
  email?: string,
  number?: string,
  about: Map<string, string>,
  professionalTitle: Map<string, string>,
  countryCode?: string,
  rooms: Map<string, Array<string>>,
};*/
/*:: export type userBranchesType = {
  statusId: number,
  branchFees: number,
  userKey: string,
  branchKey: string,
  userBranchesInsuranceProviders: Map<string, string>,
};*/
var DATA_SOURCE = exports.DATA_SOURCE = {
  ELASTIC_SEARCH: 1,
  DATABASE: 2
};

var STATUS = exports.STATUS = {
  PENDING: 1,
  ACTIVE: 2,
  INACTIVE: 3,
  DELETED: 4,
  PUBLISHED: 5
};

var PHOTO_TYPE = exports.PHOTO_TYPE = {
  PROFILE_PICTURE: 1,
  PROFESSIONAL_LICENSE: 2,
  DOCTOR_TITLE_LICENSE: 3,
  LOGO: 4,
  BRANCH_PHOTO: 5
};

var LANGUAGE = exports.LANGUAGE = {
  ENGLISH: 1,
  ARABIC: 2
};

var IMAGE_OPERATION = exports.IMAGE_OPERATION = {
  ORIGINAL: 1,
  COMPRESS: 2,
  THUMBNAIL: 3
};

var GENDER = exports.GENDER = {
  MALE: 1,
  FEMALE: 2
};

var ENTITY_TYPE = exports.ENTITY_TYPE = {
  CLINIC: 1,
  POLYCLINIC: 2,
  DOCTOR: 3
};

var PHONE_TYPE = exports.PHONE_TYPE = {
  MOBILE: 1,
  HOT_LINE: 2,
  FIXED_LINE: 3,
  ALL: 4
};